/**
 * Kleines Favicon-Badge fuer IT-Zugang-Karten.
 *
 * Holt das Favicon zur uebergebenen URL via Google's S2-Service (kostenlos,
 * keine Auth, keine API-Limits) und zeigt es als 20x20-Box neben dem
 * Programm-Namen. Faellt bei Fehler auf einen dezenten Globe-Icon zurueck.
 *
 * Hinweis: Wir nutzen ausschliesslich die HOST-Komponente der URL, niemals
 * Query/Path — so leakt kein interner Pfad an Google.
 */
import React, { useState } from 'react';
import { Globe } from 'lucide-react';

const safeHost = (url) => {
  if (!url) return null;
  try {
    return new URL(url).hostname;
  } catch {
    // Wenn die URL ohne Schema gespeichert ist ("login.microsoft.com"), versuchen wir's mit https://
    try {
      return new URL(`https://${url}`).hostname;
    } catch {
      return null;
    }
  }
};

export const Favicon = ({ url, size = 20 }) => {
  const host = safeHost(url);
  const [failed, setFailed] = useState(false);

  if (!host || failed) {
    return (
      <div
        className="rounded bg-muted flex items-center justify-center text-muted-foreground shrink-0"
        style={{ width: size, height: size }}
      >
        <Globe className="h-3 w-3" />
      </div>
    );
  }

  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${host}&sz=64`}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
      className="rounded bg-muted shrink-0"
      style={{ width: size, height: size }}
    />
  );
};

export default Favicon;
